
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getReapplyPauseTemplateResultDtoFormGroup() {
return new FormGroup({
    deleted: new FormControl<number | undefined>(undefined, [Validators.required]),
    created: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      